<div class="row">
  <div class="col-sm-12">
    <mat-form-field appearance="outline" class="selection-container w-100 tight-input {{ hasError() && 'mat-form-field-invalid' }}" subscriptSizing="dynamic">
      <mat-select [value]="value" [placeholder]="placeholder" (valueChange)="onSelectChange($event)" [disabled]="disabled" [multiple]="selectionConfig.isMultiSelect">
        @if(selectionConfig.hasEmptyValue) {
          <mat-option></mat-option>
        }
        @if(groups.length > 0) { 
          @for (group of groups; track $index) {
            <mat-optgroup [label]="group" class="f-w-500">
              @for (option of getGroupData(group); track $index) {
                <mat-option [value]="option.value" [disabled]="option.disabled">
                  @if (selectionConfig.customOptionRenderer) {
                    <ng-template *ngComponentOutlet="selectionConfig.customOptionRenderer; inputs: { option }" />
                  } @else {
                    {{ option.text | translate }}
                  }
                </mat-option>
              }
            </mat-optgroup>
          }
          @if(groups.length == 0) {
            <mat-option disabled="true">
              {{ "no data found" | translate}}
            </mat-option>
          }
        }
        @else {
          @for (option of dataSource; track $index) {
            <mat-option [value]="option.value" [disabled]="option.disabled">
              @if (selectionConfig.customOptionRenderer) {
                <ng-template *ngComponentOutlet="selectionConfig.customOptionRenderer; inputs: { option }" />
              } @else {
                {{ option.text | translate }}
              }
            </mat-option>
          }
          @if(dataSource.length == 0) {
            <mat-option disabled="true">
              {{ "no data found" | translate}}
            </mat-option>
          }
        }
      </mat-select>
      @if(loading) {
        <div class="loading-selection">
          <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </div>
      }
    </mat-form-field>
  </div>
</div>
